const ValueRestrictionType = {
  ALL_VALUES: "all-values",
  VALUE_RANGE: "value-range",
} as const;

type ValueRestrictionType =
  typeof ValueRestrictionType[keyof typeof ValueRestrictionType];

export default ValueRestrictionType;
